import { Alert, AlertDescription, AlertTitle } from '../ui/alert';

const LoadingError = ({ component }: { component?: string }) => (
  <Alert variant="destructive" className="mt-4 lg:mt-8">
    <AlertTitle>Error</AlertTitle>
    <AlertDescription>Failed to load {component}</AlertDescription>
  </Alert>
);

export default LoadingError;
